import LabFloHeroGraphic from './LabFloHeroGraphic';

export default function GlobalBackground() {
    return (
        <div className="fixed inset-0 z-0 pointer-events-none opacity-[0.05] dark:opacity-[0.08] overflow-hidden print:hidden global-bg">
            {/* Animated Background */}
            <div className="absolute inset-0 animate-float-slow">
                <LabFloHeroGraphic className="w-full h-full object-cover" />
            </div>
            
            {/* Additional floating circles */}
            <div className="absolute top-10 left-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl animate-float-delayed"></div>
            <div className="absolute bottom-10 right-10 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl animate-float"></div>

            <style>{`
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-30px); }
                    100% { transform: translateY(0px); }
                }
                @keyframes float-delayed {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-20px) translateX(15px); }
                    100% { transform: translateY(0px); }
                }
                @keyframes float-slow {
                    0% { transform: scale(1.1) rotate(0deg); }
                    50% { transform: scale(1.15) rotate(1deg); }
                    100% { transform: scale(1.1) rotate(0deg); }
                }
                .animate-float { animation: float 10s ease-in-out infinite; }
                .animate-float-delayed { animation: float-delayed 12s ease-in-out infinite; }
                .animate-float-slow { animation: float-slow 30s ease-in-out infinite; }
            `}</style>
        </div>
    );
}
